import React from 'react';

import i18n from '@/settings/i18n';
import { SubscriptionDetail } from '@/types/subscriptions/subscription';
import styled from 'styled-components';
import { BackLink } from '../BackLink';
import { Preview } from './Preview';

export type Props = {
  subscription: SubscriptionDetail;
  mode: 'new' | 'detail' | 'edit';
  onBack: () => void;
};

export const ContactPreview: React.FC<Props> = ({
  subscription,
  mode,
  onBack,
}) => {
  // See https://github.com/globis-org/glopla-dev-portal/issues/122#issuecomment-417604558
  if (subscription.projectClass) {
    return null;
  }

  return (
    <Styled>
      {subscription.billingContact && (
        <div className="content-contact-preview">
          <label className="label">
            {i18n.t('models.subscription.billingContact')}
            <BackLink mode={mode} onClick={onBack} hash="billingContact" />
          </label>
          <Preview contact={subscription.billingContact} />
        </div>
      )}

      <div className="content-contact-preview">
        <label className="label">
          {i18n.t('models.subscription.billingNote')}
          <BackLink mode={mode} onClick={onBack} hash="billingNote" />
        </label>
        <div className="content-billing-note-value">
          {subscription.billingNote}
        </div>
      </div>

      {subscription.contact && (
        <div className="content-contact-preview">
          <label className="label">
            {i18n.t('models.subscription.contact')}
            <BackLink mode={mode} onClick={onBack} hash="contact" />
          </label>
          <Preview contact={subscription.contact} />
        </div>
      )}
    </Styled>
  );
};

const Styled = styled.div`
  .label {
    display: flex;
  }
`;
